
export default class ModuleOneService {
  static getAmountOfModuleOne(header, moduleOne){
    let CCTSalary                   = header.professionalCategory.basicSalary
    let minimalSalary               = header.minimalSalary
    let serviceStationGratification = this.getServiceStationGratification(moduleOne.serviceStationGratification)
    let remunarationBase            = this.getRemunerationBase(header)
    let extraHour                   = this.getExtraHour(remunarationBase, serviceStationGratification, moduleOne.extraHour)
    let amount =
        remunarationBase +
        this.getAdditionalDanger(CCTSalary, moduleOne) +
        this.getAdditionalHealth(minimalSalary, moduleOne) +
        serviceStationGratification +
        this.getNocturneAdditional(remunarationBase,  moduleOne.additionalNocturne) +
        extraHour +
        this.getDSR(extraHour,  moduleOne.dsr, moduleOne.extraHour.has) +
        this.getOthers(moduleOne.others)
    return amount
  }
  /** 
   * @param {Number} CCTSalary
   * @param {Object} moduleOne 
   */
  static getAdditionalDanger(CCTSalary, moduleOne){
    return (CCTSalary * moduleOne.percentOfAdditionalDanger) / 100
  }

  /** 
   * @param {Number} minimalSalary
   * @param {Object} moduleOne 
   */
  static getAdditionalHealth(minimalSalary, moduleOne){
    return (minimalSalary * moduleOne.percentOfAdditionalHealth) / 100
  }
  /**
   * @param {Number} extraHour 
   * @param {Object} dsr 
   * @param {Boolean} has 
   */
  static getDSR(extraHour, dsr, has) {
    if(dsr.workingDays <= 0 || !has)
        return 0

    return extraHour * dsr.sundayDays / dsr.workingDays
  }
  /**
   * @param {Number} remunarationBase 
   * @param {Number} serviceStationGratification 
   * @param {Object} extraHour 
   */
  static getExtraHour(remunarationBase, serviceStationGratification, extraHour) {
    if (extraHour.workJournie  <= 0 || !extraHour.has)
        return 0

    let normalHour =  this.getNormalHour(remunarationBase, serviceStationGratification, extraHour)

    let hours50 = normalHour * 1.50 * extraHour.hours50

    let hours75 = normalHour * 1.75 * extraHour.hours75

    let hours100 = normalHour * 2.00 * extraHour.hours100

    return hours50 + hours75 + hours100;
  }

  /**
   * @param {Object} professionalCategory 
   */
  static getFunctionGratification(professionalCategory){
    if(!professionalCategory || !professionalCategory.costs)
      return 0
    let amount = 0;
    for (let i = 0; i < professionalCategory.costs.length; i++)
      amount += professionalCategory.costs[i].value;
    
    return amount
  }
  /**
   * @param {Number} remunarationBase 
   * @param {Object} additionalNocturne 
   */
  static getNocturneAdditional (remunarationBase, additionalNocturne){
    if(additionalNocturne.workJournie <= 0 || !additionalNocturne.has)
        return 0
    let nocturneNormalHourValue = this.getNocturneNormalHour(remunarationBase, additionalNocturne)

    let nocturneNormalHourAddPercent = nocturneNormalHourValue + ((nocturneNormalHourValue * additionalNocturne.percent) / 100)
    
    return nocturneNormalHourAddPercent * additionalNocturne.workedHours;
  }

  /** 
   * @param {Number} remunarationBase 
   * @param {Object} additionalNocturne 
   */
  static getNocturneNormalHour (remunarationBase, additionalNocturne){
    if(additionalNocturne.workJournie <= 0 || !additionalNocturne.has)
        return 0
    
    return remunarationBase / additionalNocturne.workJournie
  }
  /**
   * 
   * @param {Number} remunarationBase 
   * @param {Number} serviceStationGratification 
   * @param {Object} extraHour 
   * @returns {Number}
   */
  static getNormalHour(remunarationBase, serviceStationGratification, extraHour){
    if(extraHour.workJournie <= 0 || !extraHour.has)
      return 0
    
    return  (remunarationBase + serviceStationGratification) / extraHour.workJournie 
  }
  /**
   * @param {Array} others 
   */
  static getOthers(others){
    if(!others)
      return 0
    let amount = 0
    for (let i = 0; i < others.length; i++) {
      amount += others[i].value;
    }
    return amount
  }
  /**
   * @param {Object} header 
   */
  static getRemunerationBase(header){
    let CCTSalary                   = header.professionalCategory.basicSalary
    let functionGratification       = this.getFunctionGratification(header.professionalCategory)
    
    return CCTSalary + functionGratification
  }
  /**
   * @param {Array} serviceStationGratification 
   */
  static getServiceStationGratification(serviceStationGratification){
    if(!serviceStationGratification)
      return 0

    let amount = 0;
    for (let i = 0; i < serviceStationGratification.length; i++)
      amount += serviceStationGratification[i].value;
    
    return amount
  }
} // class



// WEBPACK FOOTER //
// ./src/service/ModuleOneService.js